import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import ReferentialBoundary from '../AdminReferentials/components/ReferentialBoundary';

/**
 * The shared admin boundary, worded for this screen. A fallback that says "this referential"
 * on a technician record sends the reader looking in the wrong place.
 */
const TechnicianBoundary = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  return <ReferentialBoundary message={t('This record could not be displayed.')}>{children}</ReferentialBoundary>;
};

export default TechnicianBoundary;
